<template>
  <div class="wrapper">
    <div class="animated fadeIn" v-if="ready">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">
        {{ this.$route.meta.label }} de materiales
      </h1>
      <b-row>
        <b-col cols="12">
          <b-card no-body>
            <form-wizard
              color="#0074d9"
              shape="circle"
              stepSize="sm"
              errorColor="#ff4136"
              ref="wizard"
              nextButtonText="Siguiente"
              backButtonText="Atrás"
              finishButtonText="Finalizar"
              @on-complete="submitForm()"
              title=""
              subtitle=""
            >
              <tab-content title="Información del documento" :before-change="formValid">
                <form-header ref="formHeader" :form="form.header" @ready="getExistingWaybill"></form-header>
                <b-alert :show="detailItemsDirty" variant="warning">Por favor ingrese detalle de la guía</b-alert>
                <form-detail ref="formDetail" :items="form.detailItems"></form-detail>
              </tab-content>
              <tab-content title="Informe de documento">
                <report :items="form.detailItems" :formHeader="form.header" />
              </tab-content>
            </form-wizard>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import FormHeader from "./FormHeader.vue";
import FormDetail from "./FormDetail.vue";
import Report from "./Report.vue";

export default {
  name: "inicio",
  components: {
    Report,
    FormWizard,
    TabContent,
    FormDetail,
    FormHeader
  },
  data() {
    return {
      ready: false,
      form: {
        header: {
          documentNumber: null,
          documentDate: null,
          documentArrivalDatetime: null,
          documentInternalNote: null,
          documentNote: null,
          documentLicensePlate: null,
          documentTruckDriver: null,
          documentTruckDriverRut: null,
          documentType: null,
          documentSenderCompany: null,
          documentClientCustomer: null,
          documentRecipientCompany: null,
          sucursal: null,
          traslado: null,
          despacho: null
        },
        detailItems: []
      },
      detailItemsDirty: false
    };
  },
  mounted() {
    this.ready = true;
  },
  computed: {
    thisRoute() {
      return this.$route.path;
    }
  },
  watch: {
    thisRoute() {
      this.ready = false;
      this.$nextTick(() => {
        this.ready = true;
      });
    }
  },
  methods: {
    toggleOverlay() {
      this.$store.dispatch("toggleOverlay");
    },
    formValid() {
      this.detailItemsDirty = false;
      const headerValid = this.$refs.formHeader.formValid();
      const detailValid = this.$refs.formDetail.itemsValid();
      if (!detailValid) {
        this.detailItemsDirty = true;
      }
      return headerValid && detailValid;
    },
    async save() {
      this.toggleOverlay();
      let details = [];
      for (let item of this.form.detailItems) {
        const documentItem = {
          supply: item.supplyId,
          quantity: item.cantidad,
          unitary_value: item.unitario,
          supply_lot: `${this.form.header.documentNumber}-${this.form.header.documentDate}-${item.codigo}`
        };
        details.push(documentItem);
      }
      const neto = details.reduce((total, item) => total + item.quantity * item.unitary_value, 0);
      // rount neto o dcimal
      const netoRounded = Math.round(neto);
      const ivaRounded = Math.round(netoRounded * 0.19);
      const totalRounded = netoRounded + ivaRounded;

      const waybill = {
        arrival_datetime: this.form.header.documentArrivalDatetime,
        waybill_date: this.form.header.documentDate,
        number: this.form.header.documentNumber,
        internal_note: null,
        note: this.form.header.documentNote,
        license_plate: this.form.header.documentLicensePlate,
        truck_driver: this.form.header.documentTruckDriver,
        waybill_type: this.$route.meta.label === "Ingreso" ? 3 : this.$route.meta.label === "Despacho" ? 4 : 5,
        client_customer: this.form.header.documentClientCustomer.value,
        company: this.form.header.documentSenderCompany.id,
        recipient_company: this.form.header.documentRecipientCompany.id,
        custom_fields: {
          sucursal: this.form.header.sucursal,
          traslado: this.form.header.traslado,
          despacho: this.form.header.despacho,
          rut_chofer: this.form.header.documentTruckDriverRut,
          neto: netoRounded,
          iva: ivaRounded,
          total: totalRounded
        },
        details: details
      };

      let url, method;
      if (this.$route.params.id) {
        url = "supplies/supply-waybill/" + this.$route.params.id + "/";
        method = "PUT";
      } else {
        url = "supplies/supply-waybill/";
        method = "POST";
      }

      try {
        const response = await this.$axios({
          method: method,
          url: url,
          data: waybill,
          headers: {
            "Content-Type": "application/json"
          }
        });
        this.toggleOverlay();
        this.$router.push("/materiales/lista");
      } catch (error) {
        this.toggleOverlay();
        this.$swal("Error", error.response.data.detail, "error");
        console.log(error);
      }
    },
    submitForm() {
      this.$swal
        .fire({
          title: "Seguro que quieres realizar esta operación?",
          text: "Verifique antes los datos ingresados",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#20a8d8",
          cancelButtonColor: "#f86c6b",
          cancelButtonText: "No",
          confirmButtonText: "Sí"
        })
        .then((result) => {
          if (result.value) {
            this.save();
          } else {
            return;
          }
        });
    },
    getExistingWaybill() {
      if (this.$route.params.id) {
        setTimeout(() => {
          const companyOptions = this.$refs.formHeader.senderOptions.concat(this.$refs.formHeader.receiverOptions);
          this.$axios.get(`supplies/supply-waybill/${this.$route.params.id}/`).then((response) => {
            this.form.header.documentNumber = response.data.number;
            this.form.header.documentDate = response.data.waybill_date;
            this.form.header.documentArrivalDatetime = response.data.arrival_datetime;
            this.form.header.documentInternalNote = response.data.internal_note;
            this.form.header.documentNote = response.data.note;
            this.form.header.documentLicensePlate = response.data.license_plate;
            this.form.header.documentTruckDriver = response.data.truck_driver;
            this.form.header.documentTruckDriverRut = response.data.custom_fields.rut_chofer;
            this.form.header.documentType = response.data.waybill_type;
            this.form.header.sucursal = response.data.custom_fields.sucursal;
            this.form.header.traslado = response.data.custom_fields.traslado;
            this.form.header.despacho = response.data.custom_fields.despacho;
            this.form.header.documentSenderCompany = companyOptions.find((e) => e.id === response.data.company);
            this.form.header.documentClientCustomer = companyOptions.find(
              (e) => e.id === response.data.client_customer
            );
            this.form.header.documentRecipientCompany = companyOptions.find(
              (e) => e.id === response.data.recipient_company
            );
            for (let detail of response.data.details) {
              this.form.detailItems.push({
                id: detail.id,
                supplyId: detail.supply,
                codigo: detail.supply_code,
                descripcion: detail.supply_name,
                cantidad: detail.quantity,
                unitario: detail.unitary_value,
                subtotal: detail.quantity * detail.unitary_value
              });
            }
            this.ready = true;
          });
        }, 500);
      }
    }
  }
};
</script>

<style scoped>
>>.wizard-header {
  padding: 0px;
}
</style>
